export type ToastProps = {
  duration?: number;
  error?: boolean;
  message: string;
  onDismiss?: () => void;
};

const useToast = () => {
  const showToast = ({
    message,
    error = false,
    duration = 5000,
    onDismiss
  }: ToastProps) => {
    shopify.toast.show(message, {
      duration,
      isError: error,
      onDismiss
    });
  };
  return { showToast };
};

export default useToast;
